// Pagina Nosotros (publico)

import React from 'react';

export default function About() {
  
  return (

    <div>
        <h1>Nosotros</h1>

      <section>
        Section
      </section>
    </div>
    
  );
}
